<template>
  <link href="https://fonts.cdnfonts.com/css/barlow" rel="stylesheet" />
  <div class="hello" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div style="display:flex; justify-content: space-around;">
      <h2 class="main-header">Assistente jurídico</h2>
      <img class="icon main-icon" src="@/assets/img/wide-logo.svg" alt="" />
      <img class="icon sup-dir-icon" src="@/assets/img/wide-line.svg" alt="" />
    </div>
    

    <div class="main-chatbox">
      <input
        placeholder="Digite uma pergunta ou comando"
        type="text"
        class="search-input"
        @keyup.enter="onEnter"
        v-model="textBox"
      />
      <img
        @click="onEnter"
        class="icon search-icon"
        src="@/assets/img/lupa.svg"
        alt=""
      />
    </div>
    <div class="chatbox-wrapper">
      <span v-if="isLoading">Aguarde enquanto sua pergunta é processada</span>
      <div id="chatbox" class="main-chatmessage">
        <div v-for="(msg, index) in msgs" :key="index">
          <div align="left" class="box user-box">
            <img
              class="icon user-icon"
              src="@/assets/img/user-chat-icon.svg"
              alt=""
            />
            <div class="user-text">
              <span> {{ msg.user }}</span>
            </div>
          </div>
          <div
            v-for="(document, index) in msg.bot.documents"
            :key="index"
            align="left"
            class="box bot-box"
          >
            <div class="user-icon-wrapper">
              <img
                class="icon user-icon"
                src="@/assets/img/vigna-chat-icon.svg"
                alt=""
              />
            </div>
            <div>
              <span v-html="document.abstract"> </span>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!--img class="icon inf-esq-icon" src="@/assets/img/inf-esq.svg" alt="" /-->
  </div>
</template>

<script>
import backgroundImage from '@/assets/img/wide-background.png';

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      botAnswer: "Justo",
      msgs: [],
      textBox: "",
      response: [],
      isLoading: false,
      backgroundImage:backgroundImage,
    };
  },
  computed: {},
  methods: {
    redirect(link) {
      window.open(link, "_blank");
    },
    convertHttpsLinksToAnchors(text) {
      // Regular expression to match links that start with "https" and end with "htm" or "html"
      const linkRegex = /https:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=]*\.htm[l]?/g;

      // Replace matched links with anchor tags
      return text.replace(linkRegex, function (match) {
        return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      });
    },
    markdownToHTML(markdown) {
      // Replace Markdown headers (h1 - h6)
      markdown = markdown.replace(/(#+)(.*)/g, function (match, hashes, text) {
        var level = hashes.length;
        return "<h" + level + ">" + text.trim() + "</h" + level + ">";
      });

      // Replace Markdown bold (**text** or __text__)
      markdown = markdown.replace(
        /\*\*(.*?)\*\*|__(.*?)__/g,
        "<strong>$1$2</strong>"
      );

      // Replace Markdown italic (*text* or _text_)
      markdown = markdown.replace(/\*(.*?)\*|_(.*?)_/g, "<em>$1$2</em>");

      // Replace Markdown inline code (`code`)
      markdown = markdown.replace(/`(.*?)`/g, "<code>$1</code>");

      // Replace Markdown links ([text](url))
      markdown = markdown.replace(
        /\[([^[]+)\]\(([^)]+)\)/g,
        '<a href="$2">$1</a>'
      );

      // Replace Markdown images (![alt text](image url))
      markdown = markdown.replace(
        /!\[([^[]*)\]\(([^)]+)\)/g,
        '<img src="$2" alt="$1">'
      );

      // Replace Markdown line breaks (two spaces at the end of a line)
      markdown = markdown.replace(/ {2}\n/g, "<br />\n");

      return this.convertHttpsLinksToAnchors(markdown);
    },
    onEnter() {
      //https://backend-u3vm4h6pda-uc.a.run.app/query user_query
      if ((this.isLoading == true)) {
        return false;
      }
      const axios = require("axios");
      this.isLoading = true;
      axios
        .post(
          "https://wide-chat-jckt54ahga-uc.a.run.app/query",
          {
            user_query: this.textBox,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.response = response.data;
          let document = {
            name: "Relatório de produtividade Etanol outubro 2023",
            abstract: "",
            link: "https://widelabs.com.br",
            tags: ["1", "2", "3", "4"],
          };
          this.msgs = [
            {
              bot: {
                documents: [],
              },
              user: this.textBox,
            },
            ...this.msgs,
          ];
          this.response.forEach((element) => {
            document.name = element["file"];
            document.link = element["path"];
            let mkdText = this.markdownToHTML(element["summary"]);
            document.abstract = mkdText;
            this.msgs[0].bot.documents.push(document);
          });
          this.textBox = "";
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  font-family: "barlow";
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
i {
  cursor: pointer;
  color: #4ac0de;
}
.main-header{
  color: #f5f5f5;
  margin-top: 10vh;
}
.hello {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-image: "";
  overflow: hidden;
}
.sup-dir-icon {
  position: absolute;
  width: 50vw;
  right: 10vw;
  margin: 0px !important;
}
.inf-esq-icon {
  position: absolute;
  width: 10vw;
  left: 0px;
  bottom: 0px;
  z-index: 0;
}
.main-chatbox {
  position: absolute;
  top: 18vh;
  left: 5vw;
  width: 90vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-radius: 24px;
}
.chatbox-wrapper {
  position: absolute;
  top: 30vh;
  left: 5vw;
  width: 90vw;
  height: 68vh;
  background-color: white;
  border-radius: 24px;
  z-index: 1;
}
.main-chatmessage {
  width: 88.5vw;
  margin-top: 2vh;
  max-height: 65vh;
  overflow-y: scroll;
  background-color: white;
  border-radius: 24px;
}
.tags {
  padding: 10px;
  margin: 5px 10px;
  border-radius: 24px;
  background-color: #82008f;
  color: white;
}
.box {
  background-color: #f5f5f5;
  margin: 20px;
  padding: 2vw;
  border-radius: 24px;
}
.user-box {
  display: flex;
  align-items: center;
}
.bot-box {
  display: flex;
  align-items: stretch;
}
.icon {
  margin-right: 30px;
}
.user-icon-wrapper {
  display: flex;
  align-items: flex-start;
}
.user-icon {
  width: 3vw;
}
.search-input {
  width: 90vw;
  border: 0px;
  font-weight: bold;
  margin-left: 20px;
}
.main-icon {
  margin-top: 5vh;
  width: 20vw;
}
.search-icon {
  height: 32px;
  width: 32px;
  margin: 20px;
}
.document-name {
  color: #82008f;
  font-weight: bolder;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background: #823476;
  width: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #823476;
}

::-webkit-scrollbar-button {
  display: none;
}
</style>
